import { CheckboxToggle, FormGroup } from "@components";
import React from "react";
import { useFormContext } from "react-hook-form";
import { ConfigModuleSetting } from "./types";

export default function ModuleSettingTravelSettings() {
	return (
		<FormGroup>
			<FlatRateSetting
				label="Verpflegungspauschale"
				name="settings.mealsFlatrate"
			/>
			<FlatRateSetting
				label="Übernachtungspauschale"
				name="settings.overnightStaysFlatrate"
			/>
			<FlatRateSetting
				label="Kilometerpauschale"
				name="settings.transportFlatrate"
			/>
		</FormGroup>
	);
}

type TravelSettingProps = {
	label: string;
	name:
		| "settings.mealsFlatrate"
		| "settings.overnightStaysFlatrate"
		| "settings.transportFlatrate";
	toggleTestId?: string;
};

function FlatRateSetting(props: TravelSettingProps) {
	const { register } = useFormContext<ConfigModuleSetting>();
	const { toggleTestId, label, name } = props;

	return (
		<CheckboxToggle
			label={label}
			data-testid={toggleTestId}
			{...register(name)}
		/>
	);
}
